import { lazy } from 'react';

export const ObjectsListLazy = lazy(() => import('./ObjectsList'));
